export enum Trophy {
  GOLD = 'GOLD',
  SILVER = 'SILVER',
  BRONZE = 'BRONZE',
}

export class TrophyConfig {
  /**
   * limites minimums pour gagner un trophé (ratio entre 0 et 1)
   */
  thresholds?: {
    gold: number;
    silver: number;
    bronze: number;
  };

  /**
   * proportion de la valeur sur le total attribué au trophée (ration entre 0 et 1)
   * la valeur pour l'or représente également la portion total des points "réservé" aux trophées
   */
  values?: {
    gold: number;
    silver: number;
    bronze: number;
  };

  constructor(trophy?: TrophyConfig) {
    this.thresholds = trophy?.thresholds?.gold ? { ...trophy.thresholds } : { gold: 1, silver: 0.75, bronze: 0.5 };
    this.values = trophy?.values?.gold ? { ...trophy.values } : { gold: 0, silver: 0, bronze: 0 };
  }
}
